module.exports = __webpack_public_path__ + "frontend/images/logos/small/small-white@2.png?1fb7a765aced8d6529f1412e3aa96e9c";